import React from 'react';
import { useTheme } from '@mui/material/styles';
import PropTypes from 'prop-types';
import LoadingButton from '@mui/lab/LoadingButton';
import EastIcon from '@mui/icons-material/East';

const Button = React.forwardRef(
  (
    {
      children,
      fullWidth = false,
      loading = false,
      loadingPosition = 'center',
      variant = 'contained',
      sx = [],
      endArrow,
      ...props
    },
    ref
  ) => {
    const theme = useTheme();

    const arrowIcon = (
      <EastIcon sx={{ mb: '2px', ml: '4px' }} fontSize="small" />
    );

    const width = fullWidth ? '100%' : 'auto';

    return (
      <LoadingButton
        disableRipple
        disableFocusRipple
        disableTouchRipple
        disableElevation
        loading={loading}
        variant={variant}
        sx={{ ...theme.shape.button, width, ...sx }}
        loadingPosition={loadingPosition}
        ref={ref}
        endIcon={endArrow ? arrowIcon : props?.endIcon}
        {...props}
      >
        {children}
      </LoadingButton>
    );
  }
);

Button.propTypes = {
  children: PropTypes.any,
  fullWidth: PropTypes.bool,
  innerRef: PropTypes.any,
  loading: PropTypes.bool,
  loadingPosition: PropTypes.oneOf(['start', 'end', 'center']),
  variant: PropTypes.string,
  sx: PropTypes.oneOfType([
    PropTypes.arrayOf(
      PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])
    ),
    PropTypes.func,
    PropTypes.object,
  ]),
  endArrow: PropTypes.bool,
  endIcon: PropTypes.any,
};

export default Button;
